import React from "react";
import ImagesAndContent from "../../components/News and Blogs/ImagesAndContent";
import PageHeader from "../../components/common/PageHeader";

const NewsBlogs = () => {
  return (
    <div>
      <PageHeader pageName={"News & Blogs"} />

      <ImagesAndContent />
    </div>
  );
};

export default NewsBlogs;
